
export const getCookie = (key) => {
  return document.cookie.split('; ').reduce((obj, pair) => {
    const [key, value] = pair.split('=');
    obj[key] = value;
    return obj;
  }, {})[key];
};

export const setCookie = (cname, cvalue, exdays, domain=window.location.hostname) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;domain=' + domain;
};
